<template>
  <div class="my n_my">
    <div class="my-top">
      <div class="flex-b my-top-filex">
        <div class="flex user_por">
          <img
            v-if="myInfo.user_info"
            :src="myInfo.user_info.avatar?myInfo.user_info.avatar:imgPath+'yj_head.png'"
            class="header"
            alt
          />
          <div class="user-info">
            <div v-if="myInfo.user_info">{{myInfo.user_info.nick_name}}</div>
            <div class="ID" v-if="myInfo.user_info">ID：{{myInfo.user_info.id}}</div>
          </div>
          <!-- {{myInfo.user_info.is_distributor == 1 ? '体验官' : '普通会员'}} -->
          <!-- v-if="myInfo.user_info.is_partner != 1" -->
          <img
            v-if="myInfo.user_info"
            class="user_fen"
            :src="imgPath + (myInfo.user_info.is_distributor == 1 ? 'yj_t_icont2.png' : 'yj_t_icont1.png')"
          />
        </div>
        <div
          class="flex authentication"
          @click="goAuth"
          v-if="isShowAuth && myInfo.user_info &&　myInfo.user_info.is_distributor == 1"
        >
          <div>去认证</div>
          <span class="iconfont iconarrow-right-bold" style="size: 10px;color: #fff"></span>
        </div>
      </div>
    </div>
    <div class="my-data">
      <div class="withdrawal" v-if="myInfo.account_switch == 1">
        <div class="flex n_mpading">
          <div>
            <div class="withdrawal-title">
              累计收益
              <span class="iconfont iconwenhao3" @click="tipToastFg('可提现金额+待入账收益+线下收益+已提现收益！')"></span>
            </div>
            <div class="withdrawal-num">￥{{myInfo.user_info.all_income_dollar}}</div>
          </div>
          <div class="buy-go" @click="goCash">明细</div>
        </div>
        <div class="flex-b">
          <div>
            <div class="withdrawal-num fons_dollor">￥{{myInfo.user_info.wait_income_dollar}}</div>
            <div class="flex-a alitem_center">
              <div class="withdrawal-title withdrawal_fons">待结算收益</div>
              <span
                class="iconfont iconwenhao3"
                @click="tipToastFg('已经产生推广订单，但是订单尚未完结；如取消订单或退款将会扣减对应的余额!')"
              ></span>
            </div>
          </div>
          <div>
            <div class="withdrawal-num fons_dollor">￥{{myInfo.user_info.offline_price_dollar}}</div>
            <div class="flex-a alitem_center">
              <div class="withdrawal-title withdrawal_fons">线下收益</div>
              <span class="iconfont iconwenhao3" @click="tipToastFg('线下转让卡的收益记录！')"></span>
            </div>
          </div>
          <div>
            <div class="withdrawal-num fons_dollor">￥{{myInfo.user_info.withdraw_dollar}}</div>
            <div class="flex-a alitem_center">
              <div class="withdrawal-title withdrawal_fons">已提现收益</div>
              <span class="iconfont iconwenhao3" @click="tipToastFg('已经提现完成的收益金额！')"></span>
            </div>
          </div>
        </div>
        <!-- <div class="flex alitem_center n_mpading">
          <div class="withdrawal-num fons_dollor">￥{{myInfo.user_info.wait_income_dollar}}</div>
          <div class="flex-a alitem_center">
            <div class="withdrawal-title withdrawal_fons">待入账收益</div>
            <span
              class="iconfont iconwenhao3"
              @click="tipToastFg('已经产生推广订单，但是订单尚未完结；如取消订单或退款将会扣减对应的余额!')"
            ></span>
          </div>
          <div class="flex-a alitem_center">
            <div class="withdrawal-title withdrawal_fons">累计收益</div>
            <div class="withdrawal-num fons_dollor">￥{{myInfo.user_info.all_dollar}}</div>
            <span class="iconfont iconwenhao3" @click="tipToastFg('待入账收益+累计收益!')"></span>
          </div>
        </div>-->
      </div>
      <!--  购买大礼包-->
      <div class="gift-bag flex-b">
        <div class="flex">
          <img :src="giftBagIcon" alt />
          <div class="gift-size">
            <div class="gift-top">体验官招募中</div>
            <div class="gift-bom">十大酒水免费得</div>
          </div>
        </div>
        <div class="gift-buy" @click="$router.push({path:'giftBig'})">去购买</div>
      </div>

      <!--        订单入口-->
      <div class="my-order mt20">
        <div class="flex-b my-order-top">
          <div class="my-order-title">我的订单</div>
          <div class="flex">
            <div @click="clickMyOrder({status: -100})">查看全部</div>
            <img :src="imgPath+'yj_arrow1.png'" alt class="yjarrow" />
          </div>
        </div>
        <div class="flex flex-a">
          <div
            v-for="(item,index) in orderList"
            @click="clickMyOrder(item)"
            :key="index"
            class="order-list"
          >
            <div class="order-list-num">
              <img :src="item.image" alt />
              <div
                v-if="myInfo.order_info&&myInfo.order_info[item.key]>0"
              >{{myInfo.order_info[item.key]}}</div>
            </div>
            <div class="order-list-name">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--  提货卡 不登录不显示-->
    <div
      class="thk_banner mt20"
      @click="goTiHuoKa"
      v-if="isLogin && myInfo.user_info && myInfo.user_info.score > 0"
    >
      <img :src="imgPath+'yj_thk.png'" alt />
    </div>
    <!--功能模块-->
    <div class="my-list">
      <!-- <div class="my-list-item flex-b" @click="$router.push({path:'hairRing'})">
        <div class="item-left flex">
          <img :src="imgPath + 'yijiu_hongbao.png'" alt />
          <div>发圈</div>
        </div>
        <div class="item-right">
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>-->
      <div class="my-list-item flex-b" @click="$router.push({path:'shopingAugment'})">
        <div class="item-left flex">
          <img :src="imgPath + 'yijiu_hongbao.png'" alt />
          <div>红包抵用券</div>
        </div>
        <div class="item-right">
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>
      <div
        class="my-list-item flex-b"
        @click="$router.push({path:'fansList'})"
        v-if="myInfo.user_info && myInfo.user_info.is_distributor == 1"
      >
        <div class="item-left flex">
          <img :src="mySucEdit" alt />
          <div>我的粉丝</div>
        </div>
        <div class="item-right">
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>
      <div class="my-list-item flex-b" @click="$router.push({path:'delivery'})">
        <div class="item-left flex">
          <img :src="imgPath + 'yj_t_cards@2x.png'" alt />
          <div>我的卡包</div>
        </div>
        <div class="item-right">
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>
      <div
        class="my-list-item flex-b"
        @click="$router.push({path:'giftGoodsBeer'})"
        v-if="myInfo.goods_count"
      >
        <div class="item-left flex">
          <img :src="myInit" alt />
          <div>待提货酒水</div>
        </div>
        <div class="item-right flex">
          <div class="yj_fen">余{{myInfo.goods_count}}</div>
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>
      <div class="my-list-item flex-b" @click="$router.push({path:'cityList'})">
        <div class="item-left flex">
          <img :src="myCity" alt />
          <div>地址管理</div>
        </div>
        <div class="item-right">
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>
      <div
        class="my-list-item flex-b"
        @click="$router.push({path:'realNameDetail'})"
        v-if="!isShowAuth"
      >
        <div class="item-left flex">
          <img :src="mySucEdit" alt />
          <div>认证信息</div>
        </div>
        <div class="item-right">
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>
      <div class="my-list-item flex-b" @click="$router.push({path:'invoiceManager'})">
        <div class="item-left flex">
          <img :src="imgPath + 'yjfapiao.png'" alt />
          <div>发票管理</div>
        </div>
        <div class="item-right">
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>
      <!-- @click="$router.push({path:'setup'})" -->

      <div class="my-list-item flex-b" @click="$router.push({path:'/liveList'})">
        <div class="item-left flex">
          <img :src="mySucEdit" alt />
          <div>回放列表</div>
        </div>
        <div class="item-right">
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>

      <div class="my-list-item flex-b" @click="tipslickFg">
        <div class="item-left flex">
          <img :src="myEdit" alt />
          <div>设置</div>
        </div>
        <div class="item-right">
          <img :src="imgPath+'yj_arrow1.png'" alt />
        </div>
      </div>
    </div>
    <van-action-sheet v-model="show" title="请您绑定手机号~~" :closeable="false">
      <div class="n_content">
        <van-field v-model="formData.mobile" placeholder="请输入手机号" type="tel" label="手机号" />
        <van-field v-model="formData.code" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <template #button>
            <van-button
              size="small"
              type="primary"
              class="n_button"
              @click="smsSend"
            >{{sign == false ? '发送验证码' : codehtml + 'S'}}</van-button>
          </template>
        </van-field>
        <div class="what">
          <div class="sc" style="background:#EDEDED;color:#0CC060" @click="show = false">暂不绑定</div>
          <div class="sc" style="background:#0CC060;color:#fff" @click="land">立即绑定</div>
        </div>
      </div>
    </van-action-sheet>
    <div class="n_versions">
      版本号: V1.0.0 |
      <span @click="$router.push({path: './storeMessage'})">店铺信息</span>
      <span style="padding: 0 5px">|</span>
      <span @click="$router.push({path: './ruleList'})">平台规则规范公示</span>
    </div>
    <div style="height:50px"></div>
    <toastMune v-if="messageFile != ''" :isToast="isToast" :message="messageFile"></toastMune>
  </div>
</template>
<script>
document.body.style.backgroundColor = '#f7f8fa'
import afterIcon from '../../assets/img/after-sales-icon.png'
import bePaidIcon from '../../assets/img/be-paid-icon.png'
import beReceivedIcon from '../../assets/img/be-received-icon.png'
import completedIcon from '../../assets/img/daipingjia@2x.png'
import deliveredIcon from '../../assets/img/delivered-icon.png'
import giftBagIcon from '../../assets/img/gift-bag-icon.png'
import myCity from '../../assets/img/my-city.png'
import myEdit from '../../assets/img/my-edit.png'
import myInit from '../../assets/img/my-init.png'
import mySucEdit from '../../assets/img/my-suc-edit.png'
import Vue from 'vue'
import { Dialog } from 'vant'
import { Toast } from 'vant'
import toastMune from '../../components/toast.vue'
import { add } from '../../public/floatPublic.js'

Vue.use(Toast)
Vue.use(Dialog)
// import { Dialog } from "../../../vant";
// Vue.use(Dialog)
// import Vue from 'vue'
// import { Dialog } from 'vant'
// import { Toast } from 'vant'
export default {
  name: 'my',
  components: { toastMune },
  data() {
    return {
      isLogin: false, //是否有登录信息
      myInfo: {}, //会员基础信息
      authInfo: {}, //获取认证信息
      isShowAuth: false, //是否显示认证
      a: 1,
      giftBagIcon,
      orderList: [
        {
          image: bePaidIcon,
          name: '待付款',
          num: '1',
          status: 0,
          key: 'waiting_paid_order',
        },
        {
          image: deliveredIcon,
          name: '待发货',
          num: '0',
          status: 1,
          key: 'waiting_delivered_order',
        },
        {
          image: beReceivedIcon,
          name: '待收货',
          num: '23',
          status: 2,
          key: 'waiting_received_order',
        },
        {
          image: completedIcon,
          name: '待评价',
          num: '0',
          status: '20',
          key: 'not_evaluate_order',
        },
        {
          image: afterIcon,
          name: '退款/售后',
          num: '12',
          status: '10',
        },
      ],
      myInit,
      myCity,
      mySucEdit,
      myEdit,
      myList: [
        {
          name: '我的兑换积分',
          num: '9000',
          image: myInit,
        },
        {
          name: '地址管理',
          image: myCity,
        },
        {
          name: '认证信息',
          image: mySucEdit,
        },
        {
          name: '设置',
          image: myEdit,
        },
      ],
      show: false,
      formData: {},
      codehtml: 60, //倒计时秒
      sign: false, //倒计时
      isToast: false,
      messageFile: '',
      bankInfo: [],
    }
  },
  created() {
    this.$store.commit('activeFailure', 4)
    this.getUserBank()
    this.init()
    this.getAuth()
  },
  mounted() {
    var token = localStorage.getItem('token')
    if (token) {
      this.isLogin = true
    }
    this.prohibitweixinShare()
  },
  // beforeRouteLeave(to, from, next) {
  //   if(to.path.indexOf(''))
  // },
  methods: {
    tipToastFg(e) {
      this.messageFile = e
      this.isToast = true
      setTimeout(() => {
        this.isToast = false
      }, 2000)
    },
    tipslickFg() {
      Toast('功能正在路上~')
    },
    smsSend() {
      if (!/^[1][0-9]{10}$/.test(this.formData.mobile)) {
        Toast('手机号码有误，请重填')
        return false
      }
      if (this.sign) return
      //获取验证码
      let { mobile, code, verifyCode } = this.formData
      this.http('Base.smsSend', { mobile: mobile }).then((res) => {
        if (res.status == 200) {
          console.log(res, '3333333')
          this.codehtml = 60
          this.sign = true
          let tim = setInterval(() => {
            this.codehtml = this.codehtml - 1
            if (this.codehtml <= 0) {
              clearInterval(tim)
              this.sign = false
              return false
            }
          }, 1000)
          this.time = tim
        } else {
          Toast(res.msg)
        }
      })
    },
    //登陆按钮
    land(e) {
      if (this.formData.mobile == '') {
        Toast('请先输入手机号')
        return
      }
      if (this.formData.code == '') {
        Toast('请先输入验证码')
        return
      }
      let flag = false
      if (flag) return
      flag = true
      let { mobile, code, verifyCode } = this.formData
      this.formData.share_sign_no = localStorage.getItem('shareId') || ''
      this.http('Client.signUp', this.formData).then((res) => {
        if (res.status == 200) {
          console.log(res, 'response.data.content')
          this.$store.commit('increment', '成功')
          let contentListy = JSON.parse(localStorage.getItem('userInfo'))
          contentListy.mobile = res.content.mobile
          contentListy = JSON.stringify(contentListy)
          localStorage.setItem('userInfo', contentListy)
          this.show = false
          flag = false
        } else {
          this.$store.commit('increment', res.msg)
          flag = false
        }
      })
    },
    //基本信息
    init() {
      this.http('Client.index', {}).then((res) => {
        localStorage.setItem('is_partner', res.content.user_info.is_partner)
        console.log(res)
        if (res.status == 200) {
          // amount_dollar
          // wait_income_dollar
          // all_income_dollar
          res.content.user_info.all_dollar = add(
            res.content.user_info.wait_income_dollar,
            res.content.user_info.all_income_dollar
          )
          console.log(res.content.user_info.all_dollar)
          this.myInfo = res.content
          if (res.content.user_info.mobile == '') {
            this.show = true
          } else {
            this.show = false
          }
        }
      })
      console.log()
      // this.a = 1
    },
    clickMyOrder(item) {
      console.log(item)
      //订单页面跳转
      if (item.status == 10) {
        this.$router.push({ path: './aftermarketList' })
        return false
      } //判断退款状态不跳转
      if (item.status == 20) {
        this.$router.push({ path: 'evaluateList' })
        return false
      }
      this.$store.commit('orderStatusFg', item.status)
      this.$nextTick(() => {
        this.$router.push({ path: 'myOrder' })
      })
    },
    //去认证
    goAuth() {
      // this.$router.push({path: '/realName',query: {real_name_fee: this.authInfo.real_name_fee,is_identity_checked:1}})
      // return
      if (this.authInfo.is_identity_checked == 1) {
        this.$router.push({
          path: '/realName',
          query: {
            real_name_fee: this.authInfo.real_name_fee_dollar,
            is_identity_checked: this.authInfo.is_identity_checked,
            is_acct_checked: this.authInfo.is_acct_checked,
          },
        })
      } else if (
        this.authInfo.is_identity_checked == 2 &&
        this.authInfo.is_sign_contract == 1
      ) {
        console.log('未签约电子协议')
        //未签约电子协议
        this.getSignContract()
      } else if (
        this.authInfo.is_identity_checked == 2 &&
        this.authInfo.is_sign_contract == 2
      ) {
        this.isShowAuth = false
      }
    },
    // 获取用户认证信息
    getAuth() {
      this.http('MemberAuth.getAuthInfo', {}).then((res) => {
        console.log(res)
        if (res.status == 200) {
          this.authInfo = res.content.auth_data
          if (
            res.content.auth_data.is_identity_checked == 1 ||
            (res.content.auth_data.is_identity_checked == 2 &&
              res.content.auth_data.is_sign_contract == 1)
          ) {
            this.isShowAuth = true
          }
        }
      })
    },
    //查询是否绑定银行卡
    getUserBank() {
      this.http('Client.getUserBank', { type: 1 }).then((res) => {
        this.bankInfo = res.content
        console.log(this.bankInfo)
      })
    },
    //去提现
    goCash() {
      if (
        this.bankInfo.length == 0 &&
        this.authInfo.is_identity_checked == 2 &&
        this.authInfo.is_sign_contract == 2
      ) {
        Dialog.confirm({
          title: '温馨提示',
          message: '您还未绑定银行卡，请前去绑卡',
        })
          .then(() => {
            this.$router.push({
              path: '/bindingBank',
              query: {
                identity_card_no: this.authInfo.identity_card_no,
                name: this.authInfo.name,
              },
            })
          })
          .catch(() => {
            // on cancel
          })
      } else if (
        this.authInfo.is_identity_checked == 1 ||
        (this.authInfo.is_identity_checked == 2 &&
          this.authInfo.is_sign_contract == 1)
      ) {
        if (this.authInfo.is_identity_checked == 1) {
          this.$router.push({
            path: '/realName',
            query: {
              real_name_fee: this.authInfo.real_name_fee_dollar,
              is_identity_checked: this.authInfo.is_identity_checked,
              is_acct_checked: this.authInfo.is_acct_checked,
            },
          })
        } else if (
          this.authInfo.is_identity_checked == 2 &&
          this.authInfo.is_sign_contract == 1
        ) {
          console.log('未签约电子协议')
          //未签约电子协议
          this.getSignContract()
        }
      } else if (this.myInfo.lg_status == 0) {
        let _this = this
        Dialog.alert({
          title: '提示',
          message: '激活提现功能，预计需要10分钟......',
          confirmButtonText: '立即激活',
        }).then(() => {
          _this.http('MemberAuth.lingGongSign').then((res) => {
            if (res.status == 200) {
              Toast('申请成功')
              this.init()
            } else {
              Toast(res.msg)
            }
          })
          // on close
        })
      } else if (this.myInfo.lg_status == 1) {
        Dialog.alert({
          title: '提示',
          message: '激活中，请稍后......',
        }).then(() => {
          // on close
        })
      } else if (
        this.authInfo.is_identity_checked == 2 &&
        this.authInfo.is_sign_contract == 2
      ) {
        this.$router.push({ path: '/wallet' })
      }
    },
    // 提现查看详情
    // goSeeInfo() {
    //   this.$router.push({ path: '/wallet' })
    // },
    //去提货卡
    goTiHuoKa() {
      this.$router.push({
        path: '/giftGoodsCont',
        query: { score: this.myInfo.user_info.score },
      })
    },
    // 获取电子协议url
    getSignContract() {
      this.http('MemberAuth.signContract', {}).then((res) => {
        if (res.status == 200) {
          console.log(res)
          window.location.href = res.content.url
        }
      })
    },
  },
}
</script>

<style scoped>
.mywithdrawal_warp {
  width: 400px;
}
.mywithdrawal_cash {
  color: #333;
  font-size: 30px;
  font-weight: bolder;
  margin-bottom: 20px;
}
.mywithdrawal_cash b {
  font-size: 38px;
  font-weight: bolder;
  color: red;
}
.mywithdrawal_cash i {
  color: red;
  font-size: 28px;
}
.yj_fen {
  line-height: 60px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #999999;
}
.yjarrow {
  width: 40px;
  height: 40px;
}
.n_my .van-action-sheet__header {
  background: rgb(243 243 243);
}
</style>
<style lang="scss" scoped>
.what {
  display: flex;
  justify-content: center;
  padding-top: 50px;
}
.sc {
  border-radius: 5px;
  background: red;
  height: 80px;
  width: 200px;
  text-align: center;
  margin: 0 20px;
  font-size: 24px;
  line-height: 80px;
}
.n_content {
  min-height: 400px;
  box-sizing: border-box;
  padding: 20px 30px;
}
.n_button {
  padding: 5px 10px;
}
// rgb(243 243 243)
.my {
  .my-top {
    width: 100vw;
    height: 310px;
    background: linear-gradient(270deg, #ff3333 0%, #ff5720 100%);
    .my-top-filex {
      padding: 54px 60px 0 20px;
      .header {
        width: 120px;
        height: 120px;
        border-radius: 50%;
      }
      .user-info {
        font-size: 32px;
        color: #ffffff;
        line-height: 32px;
        margin-left: 24px;
        margin-top: 18px;
        .ID {
          font-size: 28px;
          margin-top: 16px;
        }
      }

      .authentication {
        height: 48px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 24px;
        margin-top: 36px;
        padding: 0 17px;
        font-size: 28px;
        font-weight: 500;
        color: #ffffff;
        line-height: 48px;
        box-sizing: border-box;
      }
    }
  }
  .my-data {
    margin-top: -100px;
    .withdrawal {
      width: 710px;
      // height: 180px;
      margin: 0 auto 20px;
      padding: 30px 60px;
      background: #fff;
      box-sizing: border-box;
      border-radius: 16px;
      .withdrawal-num {
        font-size: 40px;
        font-weight: 600;
        color: #333333;
        line-height: 36px;
        // color: red;
        margin-top: 16px;
      }
      .withdrawal-title {
        font-size: 28px;
        font-weight: 400;
        color: #9da6b8;
        line-height: 28px;
        // margin-top: 16px;
      }
      .buy-go {
        width: 172px;
        height: 62px;
        background: linear-gradient(270deg, #ff3333 0%, #ff5720 100%);
        border-radius: 31px;
        font-size: 28px;
        font-weight: 500;
        color: #ffffff;
        line-height: 62px;
        text-align: center;
      }
    }

    // 订单
    .my-order {
      width: 710px;
      height: 246px;
      padding: 20px 0;
      background: #fff;
      border-radius: 16px;
      box-sizing: border-box;
      display: block;
      margin: 0 auto;

      .my-order-top {
        font-size: 28px;
        font-weight: 400;
        color: #9da6b8;
        line-height: 42px;
        padding: 0 40px;
        padding-bottom: 18px;
        border-bottom: 1px solid #f0f0f0;
      }

      .my-order-title {
        font-size: 30px;
        font-weight: 500;
        color: #343f4a;
        line-height: 42px;
      }

      .order-list {
        font-size: 26px;
        font-weight: 500;
        color: #333333;
        line-height: 26px;
        margin-top: 38px;
        .order-list-name {
          margin-top: 17px;
          font-size: 26px;
          font-weight: 500;
          color: #333333;
          line-height: 26px;
        }

        .order-list-num {
          width: 56px;
          height: 56px;
          position: relative;
          margin: 0 auto;
          img {
            width: 56px;
            height: 56px;
          }
          div {
            position: absolute;
            height: 32px;
            border-radius: 16px;
            border: 1px solid #ffffff;
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
            line-height: 32px;
            right: -18px;
            top: -9px;
            background: #ee0a24;
            padding: 0 10px;
          }
        }
      }
    }
  }

  .gift-bag {
    width: 710px;
    height: 100px;
    background: linear-gradient(90deg, #313131 0%, #595959 100%);
    border-radius: 14px;
    margin: 20px auto 0;
    box-sizing: border-box;
    padding: 19px 52px 19px 36px;
    img {
      width: 56px;
      height: 56px;
      margin-top: 3px;
    }
    .gift-size {
      margin-left: 22px;
      color: #fedeb1;
      .gift-top {
        font-size: 28px;
        font-weight: bold;
        line-height: 28px;
      }
      .gift-bom {
        font-size: 24px;
        font-weight: 500;
        line-height: 24px;
        margin-top: 10px;
      }
    }

    .gift-buy {
      width: 172px;
      height: 62px;
      text-align: center;
      background: linear-gradient(90deg, #ffe3bc 0%, #ffebd0 100%);
      border-radius: 31px;
      font-size: 28px;
      color: #383838;
      line-height: 62px;
    }
  }
  .thk_banner {
    width: 710px;
    height: 144px;
    margin: 0 auto;
    img {
      width: 710px;
      height: 144px;
    }
  }
  .my-list {
    width: 710px;
    margin: 20px auto;
    box-sizing: border-box;
    padding: 0 40px;
    background: #ffffff;
    border-radius: 14px;
    .my-list-item {
      padding: 20px 0;
      .item-left {
        font-size: 28px;
        font-weight: 500;
        color: #333333;
        line-height: 60px;
        img {
          width: 60px;
          height: 60px;
          display: block;
          margin-right: 20px;
        }
      }
      .item-right img {
        width: 40px;
        height: 40px;
        margin-top: 10px;
      }
    }
    .my-list-item + .my-list-item {
      border-top: 1px solid #f0f0f0;
    }
  }
}
.n_versions {
  padding: 20px 0;
  text-align: center;
  margin-bottom: 150px;
  font-size: 24px;
  color: #9da6b8;
}
.alitem_center {
  align-items: flex-end;
}
.n_mpading {
  // margin-left: 60px;
  justify-content: space-between;
  margin-top: 22px;
  margin-bottom: 20px;
}
.withdrawal_fons {
  font-size: 24px !important;
  color: #9da6b8;
}
.fons_dollor {
  font-size: 30px !important;
}
.user_por {
  position: relative;
}
.user_fen {
  width: 130px;
  box-sizing: border-box;
  position: absolute;
  bottom: -5px;
  left: -5px;
  padding: 5px 0;
}
.visicon_nn {
  vertical-align: bottom;
}
.iconwenhao3 {
  font-size: 30px;
  margin-left: 5px;
}
</style>